/**
 * Renders a form in the style that is currently used in Bottlebooks designs:
 * - labels are rendered above the field.
 * - fields have borders around them.
 * TODO Implement.
 *
 * @type {import("../useFormTheme").FormTheme}
 */
const classic = {
    form: {},
    fieldLayout: { paddingBottom: 2 },
    label: { variant: 'label.small' },
    field: {},
    input: {},
    checkbox: {},
    radio: {},
    textArea: { width: '100%', border: 1, borderColor: 'borderSecondary' },
    description: {},
    warning: {},
    error: { display: 'block' },
};
export default classic;
//# sourceMappingURL=classic.js.map